var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFurniture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10478_3708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.5C38.531 49.5 49.5 38.531 49.5 25C49.5 11.469 38.531 0.5 25 0.5C11.469 0.5 0.5 11.469 0.5 25C0.5 38.531 11.469 49.5 25 49.5Z",
    fill: "white",
    stroke: "#DCF1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0525 30.5L35 35H37L36.5265 30.5H34.0525ZM15.9475 30.5L15 35H13L13.4735 30.5H15.9475ZM24.25 15.44V24.44C23.905 24.165 23.47 24 23 24H17.775C17.41 24 17.065 24.1 16.775 24.265V23.385C16.775 21.52 15.255 20 13.385 20C13.255 20 13.125 20.01 13 20.025V17C13 15.895 13.895 15 15 15H23C23.47 15 23.905 15.165 24.25 15.44ZM37 17V20.025C36.875 20.01 36.745 20 36.615 20C34.745 20 33.225 21.52 33.225 23.385V24.265C32.935 24.1 32.59 24 32.225 24H27C26.53 24 26.095 24.165 25.75 24.44V15.44C26.095 15.165 26.53 15 27 15H35C36.105 15 37 15.895 37 17Z",
    fill: "#343A40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.226 27.0006V23.3871C34.2264 23.0649 34.2921 22.7461 34.4191 22.4499C34.5461 22.1538 34.7317 21.8864 34.9648 21.664C35.1979 21.4415 35.4737 21.2685 35.7754 21.1555C36.0772 21.0425 36.3987 20.9918 36.7206 21.0064C37.0425 21.021 37.3581 21.1006 37.6484 21.2404C37.9387 21.3803 38.1976 21.5775 38.4096 21.8202C38.6217 22.0628 38.7823 22.3459 38.882 22.6523C38.9816 22.9587 39.0182 23.2822 38.9895 23.6031L38.3915 30.1816C38.3463 30.6787 38.1169 31.1409 37.7483 31.4775C37.3797 31.8141 36.8986 32.0007 36.3995 32.0006H13.5995C13.1004 32.0007 12.6192 31.8141 12.2507 31.4775C11.8821 31.1409 11.6527 30.6787 11.6075 30.1816L11.0095 23.6031C10.9808 23.2822 11.0174 22.9587 11.117 22.6523C11.2167 22.3459 11.3773 22.0628 11.5894 21.8202C11.8014 21.5775 12.0603 21.3803 12.3506 21.2404C12.6409 21.1006 12.9565 21.021 13.2784 21.0064C13.6003 20.9918 13.9218 21.0425 14.2236 21.1555C14.5253 21.2685 14.8011 21.4415 15.0342 21.664C15.2673 21.8864 15.4529 22.1538 15.5799 22.4499C15.7069 22.7461 15.7726 23.0649 15.773 23.3871V27.0006H34.226Z",
    fill: "#343A40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10478_3708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture);
export default __webpack_public_path__ + "static/media/furniture.71cd0b1ddf4515c211dbd2942cc3b23d.svg";
export { ForwardRef as ReactComponent };